var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "tenders-table" }, [
    _c("caption", { staticClass: "tenders-table__title" }, [
      _vm._v(_vm._s(_vm.tableTitle)),
    ]),
    _vm._v(" "),
    _c("thead", [
      _c(
        "tr",
        { staticClass: "no-hover" },
        [
          _c("th", { staticClass: "w-1" }, [_vm._v("Год")]),
          _vm._v(" "),
          _vm._l(_vm.theadList, function (t, i) {
            return _c("th", { key: i }, [_vm._v(_vm._s(t))])
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.years.length
      ? _c(
          "tbody",
          [
            _vm._l(_vm.years, function (y, i) {
              return _c("tr", { key: i }, [
                _c("td", { staticClass: "w-1 print-grey" }, [
                  _vm._v(_vm._s(y)),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "table-btn",
                      on: {
                        click: function ($event) {
                          return _vm.getFullInfo(y)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.stat[y][_vm.keys[0][0]]))]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "на " +
                        _vm._s(
                          _vm.moneyFormat(
                            _vm.stat[y][_vm.keys[0][1]] / 1000000,
                            2
                          )
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0, true),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "table-btn",
                      on: {
                        click: function ($event) {
                          return _vm.getFullInfo(y)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.stat[y][_vm.keys[1][0]]))]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "на " +
                        _vm._s(
                          _vm.moneyFormat(
                            _vm.stat[y][_vm.keys[1][1]] / 1000000,
                            2
                          )
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(1, true),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm._m(2),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("tfoot", [
      _c("tr", { staticClass: "no-hover" }, [
        _c("td", { staticClass: "w-1 print-grey" }, [_vm._v("Все годы")]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(_vm.stat.total[_vm.keys[0][0]]))]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "на " +
                _vm._s(
                  _vm.moneyFormat(_vm.stat.total[_vm.keys[0][1]] / 1000000, 2)
                )
            ),
          ]),
          _vm._v(" "),
          _vm._m(3),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(_vm.stat.total[_vm.keys[1][0]]))]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "на " +
                _vm._s(
                  _vm.moneyFormat(_vm.stat.total[_vm.keys[1][1]] / 1000000, 2)
                )
            ),
          ]),
          _vm._v(" "),
          _vm._m(4),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "measure" }, [
      _vm._v("млн. "),
      _c("i", { staticClass: "uk-icon-rub" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "measure" }, [
      _vm._v("млн. "),
      _c("i", { staticClass: "uk-icon-rub" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "no-hover no_print" }, [
      _c("td", { staticClass: "last-cell", attrs: { colspan: "3" } }, [
        _c("hr"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "measure" }, [
      _vm._v("млн. "),
      _c("i", { staticClass: "uk-icon-rub" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "measure" }, [
      _vm._v("млн. "),
      _c("i", { staticClass: "uk-icon-rub" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }